let count = 0
const fileUpdateMetadata = (file, i) => {
    if (file.id == null) file.id = `_${Date.now()}_${count++}`
    if (file.originalPosition == null) file.originalPosition = i

    file.position = i

    return file
}

export default fileUpdateMetadata